import { render } from "./MandatoryDetail.vue?vue&type=template&id=29822e7c"
import script from "./MandatoryDetail.vue?vue&type=script&lang=ts"
export * from "./MandatoryDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script